import { AccountInformation, Fond, Police, Rueckkauf } from '../../_generated';
import { MultiLanguageProperty } from './language.models';
import TagEnum = Rueckkauf.TagEnum;

export interface PoliceViewDetail {
    policennummer: string;
    vertragsbeginn: string;
    vorsorgeart: VorsorgeartViewEnum;
    active: boolean;
    produktName: MultiLanguageProperty;
    formattedErlebensfallsumme: string | null;
    formattedTodesfallsumme: string | null;
    formattedErwerbsunfaehigkeitsrente: string | null;
    formattedLeibrente: string | null;
    formattedTechnischerZins: string | null;
    beguenstigungTodesfallText: string | null;
    beguenstigungTodesfall: 'default' | 'individually' | null;
    fonds: Fond[];
    fondNames: string[];
    inkassoart: Police.InkassoartEnum;
    rueckkauf: PoliceViewRueckkauf | null;
    formattedRatenpraemie: string | null;
    zahlungsart: string;
    formattedJahrespraemie: string | null;
    formattedEinmalpraemie: string | null;
    zahlungsmethode: string | null;
    praemienSaldo: number;
    formattedRueckkaufswertDatum: string | null;
    isRisiko: boolean;
    isFondspolice: boolean;
    isTerzaFlex: boolean;
    isPaxExtra: boolean;
    isLeibRente: boolean;
    isDiamondLife: boolean;
    haupttarifNummer: string;
    beguenstigungTodUnwiderruflich: boolean;
    vnVtUneinheitlich: boolean;
    kontoInformationen: AccountInformation[];
    zahlungsfrequenzWirkungsdatum: string | null;
    todesfallsumme: number;
    erwerbsunfaehigkeitsrente: number;
    jahrespraemie: number;
    jahrespraemieErhoehungErlaubt: boolean;
    jahrespraemieReduktionErlaubt: boolean;
    risikozwischenversicherungBeginn: string | null;
    risikozwischenversicherungEnde: string | null;
}

export interface PoliceViewAnpassungDisplayOptions {
    canChangeBeguenstigung: boolean;
    canChangeFondswitch: boolean;
    canRequestPraemienfreistellung: boolean;
    canChangeVorsorgeart: boolean;
    canChangeVersicherungsnehmer: boolean;
    canChangeDynamik: boolean;
    canChangeAutomatischeAnpassung: boolean;
    canChangeJahrespraemie: boolean;
    canChangeZahlungsmethode: boolean;
    canRequestFondsvorauszahlung: boolean;
    canRequestErwerbsunfaehigkeit: boolean;
    canRequestWiederinkraftsetzung: boolean;
    canRequestRisikozwischenversicherung: boolean;
    canRequestRueckerstattung3a: boolean;
    showZahlungsart: boolean;
    showRueckkauf: boolean;
    showTechnischerZins: boolean;
}

/**
 * Exisits for better readability because Police.VorsorgeartEnum are magic strings
 * F = Saeule 3b
 * G = Saeule 3a
 * V = Vadoise
 */
export enum VorsorgeartViewEnum {
    Saeule3b = 'F',
    Saeule3a = 'G',
    Vadoise = 'V',
}

export interface PoliceViewRueckkauf {
    policennummer: string;
    rueckkaufswert: number;
    formattedRueckkaufswert: string | null;
    formattedRueckkaufswertDate: string | null;
    formattedUeberschuss: string | null;
    formattedTotal: string | null;
    isTagNull: boolean | null;
    isTagVerzicht: boolean | null;
    isTagRisikoversicherung: boolean | null;
    isTagLeibrentenpolice: boolean | null;
    isTagFondspolice: boolean | null;
    tag: TagEnum;
}

export interface PoliceViewList {
    policennummer: string;
    produktName: MultiLanguageProperty;
    vorsorgeart: string;
    active: boolean;
    zahlungsart: Police.ZahlungsartEnum;
    saldo: number;
    isPraemieFaellig: boolean;
}

export enum Tarifcodes {
    TARIFCODE_912 = '000912',
    TARIFCODE_915 = '000915',
    TARIFCODE_918 = '000918',
    TARIFCODE_919 = '000919',
    TARIFCODE_946 = '000946',
    TARIFCODE_952 = '000952',
    TARIFCODE_954 = '000954',
    TARIFCODE_955 = '000955',
    TARIFCODE_957 = '000957',
    TARIFCODE_958 = '000958',
}

export const GENERAL_MINIMUM = 1200;
export const CHILDREN_MINIMUM = 1000;
export const TOD_MINIMUM = 10000;
export const EU_MINIMUM = 9600;

export enum Fondscode {
    PAX_FONDS_AKTIEN_SCHWEIZ = '001300',
    PAX_FONDS_AKTIEN_EUROPA_EX_SCHWEIZ = '001302',
    PAX_FONDS_PORTFOLIO_25 = '001304',
    PAX_FONDS_PORTFOLIO_50 = '001305',
    PAX_FONDS_PORTFOLIO_75 = '001306',
    PAX_FONDS_PORTFOLIO_100 = '001307',
    PAX_FONDS_PORTFOLIO_ZIELRENDITE = '001308',
    PAX_FONDS_PORTFOLIO_QUALITY_SELECT = '001309',
}
